import { N3xusApiSettings } from '../base/n3xus/types'
//These are the public keys the private should NEVER be stored in the front end.  This library is for the front end only.
export const MAGIC_STAGE_API = 'pk_live_8179F7D8ACCC5975'
export const MAGIC_PROD_API = 'pk_live_890742524BD0A1F8'

// N3XUS
export const N3XUS_DEVELOPMENT_API: N3xusApiSettings = {
    HOST: 'https://api-development.n3xus.services',
    ENDPOINT: '/api',
    VERSION: '/2023-01',
    ENV: 'DEVELOPMENT'
}
export const N3XUS_STAGE_API: N3xusApiSettings = {
    HOST: 'https://api-stage.n3xus.services',
    ENDPOINT: '/api',
    VERSION: '/2023-01',
    ENV: 'STAGE'
}
export const N3XUS_API: N3xusApiSettings = {
    HOST: 'https://api.n3xus.services',
    ENDPOINT: '/api',
    VERSION: '/2023-01',
}
export const N3XUS_API_LOCAL = {
    HOST: '',
    ENDPOINT: '/api',
    VERSION: '/2023-01',
    ENV: 'STAGE'
}

